import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ThemeContext } from "./theme";
//import s2Image from "./photos/s4.png";
import s7Image from "../Images/photos/s7.png";
import { Routes, Route } from "react-router-dom";

// Pages
import ConfigurationManagement from "./ConfigurationManagement";
import AdminAccountCreation from "./AdminAccountCreation";
import SidebarWithTopbar from "./sidebar2";
import { apiFetch } from "../context/AuthContext";
import { useProfile } from "../hooks/useProfile";



// Icons from lucide-react
import {
  User,
  LogOut,
  Bell,
  Plug,
  MapPinOff,
  Network,
  Settings,
  BarChart3,
  CalendarCheck,
  Users,
  CalculatorIcon,
  Calendar as CalendarIcon,
  FileText,
  Home,
  CreditCard,
  Sun,
  Moon,
  Calculator,
  GitPullRequestIcon,
  BookCheckIcon,
  DollarSignIcon,
  Coffee,
  LockIcon,
  SettingsIcon,
  ShieldPlus
} from "lucide-react";

const allowedArea = {
  lat: process.env.REACT_APP_OFFICE_LATITUDE, // example Cairo
  lng: process.env.REACT_APP_OFFICE_LONGITUDE,
  radius: 10000, // in meters (200m around point)
};


// Helper: calculate distance between two lat/lng in meters (Haversine formula)
function getDistance(lat1, lon1, lat2, lon2) {
  const R = 6371000; // Earth radius in m
  const toRad = (deg) => (deg * Math.PI) / 180;

  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) *
    Math.cos(toRad(lat2)) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // distance in meters
}

function ProfessionalDashboard() {
  // Theme Context
  const { theme, setTheme } = useContext(ThemeContext);
  const { profile } = useProfile();

  // 🔹 Add location state
  const [userLocation, setUserLocation] = useState(null);
  const [locationError, setLocationError] = useState(null);

  // Fetch user location on mount
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setUserLocation({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          });
        },
        (err) => {
          console.error("Error getting location:", err);
          setLocationError("Location access denied. Please enable it.");
        }
      );
    } else {
      setLocationError("Geolocation is not supported in this browser.");
    }
  }, []);

  // State for employee counts and payroll
  const [employeeCount, setEmployeeCount] = useState(0);
  const [totalCompanies, setTotalCompanies] = useState(15);
  const [counts, setCounts] = useState({ Active: 0, OnLeave: 0, Recent: 0 });
  const [payrollTotal, setPayrollTotal] = useState(0);

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  // Fetch employee total count
  useEffect(() => {
    apiFetch(`${BASE_URL}/employees/count`, { method: "GET" })
      .then((res) => res.json())
      .then((data) => setEmployeeCount(data.count))
      .catch((err) => console.error(err));
  }, []);

  // Fetch counts for Active, OnLeave, and Recent employees
  useEffect(() => {
    async function fetchCounts() {
      try {
        const activeRes = await apiFetch(`${BASE_URL}/employees/Active`, { method: "GET" });
        const onLeaveRes = await apiFetch(`${BASE_URL}/employees/OnLeave`, { method: "GET" });
        const active = await activeRes.json();
        const onLeave = await onLeaveRes.json();
        setCounts({ Active: active.count, OnLeave: onLeave.count, Recent: 7 });
      } catch (err) {
        console.error(err);
      }
    }
    fetchCounts();
  }, []);

  // Fetch total payroll
  useEffect(() => {
    apiFetch(`${BASE_URL}/payroll/total`, { method: "GET" })
      .then((res) => res.json())
      .then((data) => setPayrollTotal(data.total))
      .catch((err) => console.error(err));
  }, []);

  // User info from /users/me (profile), fall back to localStorage
  const user = {
    username: profile?.employeeName || localStorage.getItem("emoloyeeName"),
    email: profile?.employeeEmail || localStorage.getItem("email"),
    role: profile?.role || localStorage.getItem("role"),
  };

  const [notifications, setNotifications] = useState(3);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [currentPage, setCurrentPage] = useState(() => {
    // استرجاع الصفحة المحفوظة عند التحميل
    const savedPage = localStorage.getItem('adminCurrentPage');
    return savedPage || 'DashboardSuper';
  });
  const [language, setLanguage] = useState("en");

  const navigate = useNavigate();
  const { logout } = useAuth();

  // Toggle between light and dark theme
  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
  };
  useEffect(() => {
    // حفظ الصفحة الحالية في localStorage عند تغييرها
    localStorage.setItem('adminCurrentPage', currentPage);
  }, [currentPage]);

  // Get background image based on theme
  // const getBackgroundImage = () => (theme === "light" ? s7Image : s2Image);

  // Logout function
  const handleLogout = () => {
    try {
      logout();
      try {
        localStorage.removeItem('nav_admin');
        localStorage.removeItem('nav_manager');
        localStorage.removeItem('nav_employee');
      } catch (e) { }
      navigate("/login");
    } catch (error) {
      console.error("Logout error:", error);
      navigate("/login");
    }
  };





  // Change current page


  const handlePageChange = (page) => {
    setCurrentPage(page);
    navigate(`/DashboardSuper/${page}`); // ضيف السطر ده
  };



  // Navigation menu items
  const navItems = [
    { icon: SettingsIcon, text: "Configurations", page: "ConfigurationManagement" },
    { icon: ShieldPlus, text: "Admin Accounts", page: "AdminAccountCreation" },
  ];

  // Renderers for all pages
  const renderconfigurations = () => <ConfigurationManagement />;
  const renderAdminAccountCreation = () => <AdminAccountCreation />;


  // Placeholder renderer for under-development pages
  const renderOtherPage = (pageName) => (
    <div>
      <div style={{ marginBottom: "32px" }}>
        <h1
          style={{
            color: theme === "light" ? "#0f172a" : "white",
            fontSize: "28px",
            fontWeight: "700",
          }}
        >
          {pageName}
        </h1>
        <p
          style={{
            color: theme === "light" ? "#64748b" : "rgba(255,255,255,0.8)",
          }}
        >
          This page is under development and will be available soon
        </p>
      </div>
      <div
        style={{
          padding: "24px",
          background: theme === "light" ? "#fff" : "#1e293b",
          borderRadius: "16px",
          textAlign: "center",
        }}
      >
        <Settings size={64} />
        <h3 style={{ color: theme === "light" ? "#0f172a" : "white" }}>
          {pageName} Page
        </h3>
        <p
          style={{
            color: theme === "light" ? "#64748b" : "rgba(255,255,255,0.6)",
          }}
        >
          This page will contain all features and tools
          <br />
          needed for effective {pageName.toLowerCase()} management
        </p>
      </div>
    </div>
  );

  // Render current page based on navigation
  const renderCurrentPage = () => {
    switch (currentPage) {
      case "renderconfigurations":
        return renderconfigurations();
      default:
        return renderconfigurations();
    }
  };

  // Main render
  return (

    <div
      style={{
        minHeight: "100vh",
        fontFamily: "Segoe UI, Roboto, sans-serif",
        position: "relative",
      }}
    >
      {/* Background image */}

      <div style={{ position: "absolute", inset: 0, pointerEvents: "none" }}>
        <div
          style={{
            position: "absolute",
            top: "-140px",
            right: "-120px",
            width: "300px",
            height: "300px",
            borderRadius: "50%",
            filter: "blur(60px)",
            background:
              theme === "light"
                ? "rgba(59,130,246,0.05)"
                : "rgba(99,102,241,0.1)",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "-140px",
            left: "-140px",
            width: "320px",
            height: "320px",
            borderRadius: "50%",
            filter: "blur(60px)",
            background:
              theme === "light"
                ? "rgba(139,92,246,0.05)"
                : "rgba(59,130,246,0.1)",
          }}
        />
      </div>

      {/* Sidebar with Topbar */}
      <SidebarWithTopbar
        navItems={navItems}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
        user={user}
        notifications={notifications}
        handleLogout={handleLogout}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        themeToggle={
          <button
            style={{
              padding: "8px",
              borderRadius: "12px",
              cursor: "pointer",
              color: theme === "light" ? "#0f172a" : "white",
              background:
                theme === "light" ? "rgba(0,0,0,0.1)" : "rgba(255,255,255,0.1)",
            }}
            onClick={toggleTheme}
          >
            {theme === "light" ? <Moon size={20} /> : <Sun size={20} />}
          </button>
        }
      >
        <div style={{ padding: "32px 24px" }}>{<Routes>
          <Route path="/ConfigurationManagement" element={renderconfigurations()} />
          <Route path="/AdminAccountCreation" element={renderAdminAccountCreation()} />
        </Routes>}</div>
      </SidebarWithTopbar>
    </div>
  );
}

export default ProfessionalDashboard;